import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ags-info-encadrement',
  templateUrl: './info-encadrement.component.html',
  styleUrls: ['./info-encadrement.component.scss']
})
export class InfoEncadrementComponent implements OnInit {
  @Input() detail;
  @Output() public goToDetailOutput = new EventEmitter<number>();

  public isClicked = false;

  constructor() {}

  ngOnInit() {}

  seeDetails() {
    const idSession = this.detail.id;
    this.goToDetailOutput.emit(Number(idSession || 0));
  }

  refuse() {
    window.open(`${this.detail.urlRefuse}`);
    this.isClicked = true;
  }

  accept() {
    window.open(`${this.detail.urlAccept}`);
    this.isClicked = true;
  }
}
